import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLabProfile = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_10035_25396",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 20,
		height: 20,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_10035_25396)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M6.875 9.79158V8.54158H13.125V9.79158H6.875ZM6.875 6.45825V5.20825H13.125V6.45825H6.875ZM5 11.8749H11.25C11.6207 11.8749 11.9636 11.9551 12.2787 12.1153C12.594 12.2756 12.8617 12.5021 13.0817 12.7947L15 15.2949V3.58971C15 3.51485 14.976 3.45339 14.9279 3.40534C14.8799 3.35728 14.8184 3.33325 14.7435 3.33325H5.25646C5.1816 3.33325 5.12014 3.35728 5.07208 3.40534C5.02403 3.45339 5 3.51485 5 3.58971V11.8749ZM5.25646 16.6666H14.4727L12.0977 13.5593C11.993 13.4214 11.8683 13.3145 11.7235 13.2387C11.5788 13.1628 11.421 13.1249 11.25 13.1249H5V16.4101C5 16.485 5.02403 16.5464 5.07208 16.5945C5.12014 16.6426 5.1816 16.6666 5.25646 16.6666ZM14.7435 17.9166H5.25646C4.83549 17.9166 4.47917 17.7708 4.1875 17.4791C3.89583 17.1874 3.75 16.8311 3.75 16.4101V3.58971C3.75 3.16874 3.89583 2.81242 4.1875 2.52075C4.47917 2.22909 4.83549 2.08325 5.25646 2.08325H14.7435C15.1645 2.08325 15.5208 2.22909 15.8125 2.52075C16.1042 2.81242 16.25 3.16874 16.25 3.58971V16.4101C16.25 16.8311 16.1042 17.1874 15.8125 17.4791C15.5208 17.7708 15.1645 17.9166 14.7435 17.9166Z",
			fill: "#064C68"
		})
	})]
});
export default SvgLabProfile;
